import { render, staticRenderFns } from "./BuildingOwnerTantiemes.vue?vue&type=template&id=ec8d15b2&"
import script from "./BuildingOwnerTantiemes.vue?vue&type=script&lang=js&"
export * from "./BuildingOwnerTantiemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports